module.exports = __webpack_public_path__ + "assets/img/title-5be18c07.png";